<template>
    <select class="uk-select uk-form-small uk-form-width-small" @change="fireChange">
        <option value="" v-if="withPlaceholder">{{ placeholderLabel }}</option>
        <option v-for="column in columnsWithOrders" :value="column.value" :selected="isSelected(column.value)" v-html="column.label">
        </option>
    </select>
</template>
<script>
  import DataGridOrders from 'js/theme-mixins/DataGridOrders';

  export default {
    mixins: [DataGridOrders],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridOrders.vue